
export default {
  getStatusLabels () {
    const lbl = ['New', 'Submit', 'Working', 'Completed']
    return lbl
  },
  getStatuses () {
    const st = {
      New: {
        label: 'Not Started',
        name: 'New',
        badge: 'NEW',
        badgeToolTip: 'Goal has not been started',
        badgeClass: 'badge-new',
        id: 0,
        bigImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/clipboard-plus.svg')
        },
        smallImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/clipboard-plus.svg')
        }
      },
      PendingApproval: {
        label: 'Pending Approval',
        name: 'PendingApproval',
        badge: 'PEND',
        badgeToolTip: 'Goal is pending approval from your ticket counselor',
        badgeClass: 'badge-pend',
        id: 1,
        bigImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/alarm.svg')
        },
        smallImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/alarm.svg')
        }
      },
      InProgress: {
        label: 'In Progress',
        name: 'InProgress',
        id: 2,
        badge: 'WORK',
        badgeToolTip: 'Goal is in progress',
        badgeClass: 'badge-work',
        bigImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/gear.svg')
        },
        smallImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/gear.svg')
        }
      },
      Completed: {
        label: 'Completed',
        name: 'Completed',
        badge: 'DONE',
        badgeToolTip: 'Goal is complete. YEAH!',
        badgeClass: 'badge-done',
        id: 3,
        bigImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/award.svg')
        },
        smallImageUrl: function () {
          return require('@/assets/bootstrap-icons/icons/award.svg')
        }
      }
    }
    return st
  },
  getEmptyPatrolStatus: function (patrolName) {
    return {
      emptySet: 'yes',
      hoverBackgroundColor: 'red',
      hoverBorderWidth: 10,
      labels: this.getStatusLabels(),
      datasets: [
        {
          label: patrolName,
          backgroundColor: ['#41B883', '#FF00FF', '#00FF00', '#999999'],
          data: [0, 0, 0, 0]
        }
      ]
    }
  }
}
